import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { appRoutes } from '@app/routes'
import { OnboardingSurvey } from './OnboardingSurvey'

export const OnboardingSurveyRouter: React.FC = () => {
  return (
    <Switch>
      <Route
        exact
        path={appRoutes.signupOnboardingSurvey.path}
        component={OnboardingSurvey}
      />
    </Switch>
  )
}
